import type { ReactElement } from 'react';
import React from 'react';
import * as m from '../paraglide/messages.js';
import { ChatMarkdown } from './chatMarkdown.js';
import { splitStudioNotice } from './studioNotice.js';

export type ChatNoticeProps = {
  readonly text: string;
};

/** Renders soft French copy first; optional technical stdout behind a collapsible. */
export function ChatNotice(props: ChatNoticeProps): ReactElement {
  const notice = splitStudioNotice(props.text);
  return (
    <>
      {notice.summary !== '' ? <ChatMarkdown text={notice.summary} /> : undefined}
      {notice.technicalDetails !== undefined && notice.technicalDetails !== '' ? (
        <details className="chat-technical-details">
          <summary>{m.technicalDetails()}</summary>
          <pre className="chat-technical-details-body">{notice.technicalDetails}</pre>
        </details>
      ) : undefined}
    </>
  );
}
